module.exports = __webpack_public_path__ + "img/4-6.248f4987.png";